// WorkflowType -> Set of WorkflowTypes
// entries must always be bidirectional
export const invalidSaveToWorkflowTypes = {
  business: new Set([
    'reconciliation',
    'router',
    'transaction',
  ]),
  person: new Set([
    'reconciliation',
    'router',
    'transaction',
  ]),
  reconciliation: new Set([
    'business',
    'person',
  ]),
  router: new Set([
    'business',
    'person',
  ]),
  transaction: new Set([
    'business',
    'person',
  ]),
};
